import type { ReviewLink, RowState } from './types';

/** "7 Oct 2026" - the design's date, and en-GB's own "Sept" for September. */
export function formatDay(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

/** "7 Oct, 02:44". */
export function formatDayTime(iso: string): string {
  return new Date(iso).toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/** "Tooth 26 · v1", "Teeth 45, 46 · v2", or just "v1" when no tooth was given. */
export function teethLabel(link: ReviewLink): string {
  const version = `v${String(link.version)}`;
  if (link.teeth.length === 0) return version;
  const noun = link.teeth.length === 1 ? 'Tooth' : 'Teeth';
  return `${noun} ${link.teeth.join(', ')} · ${version}`;
}

export const STATE_LABEL: Record<RowState, string> = {
  awaiting: 'Awaiting review',
  changes_requested: 'Changes requested',
  approved: 'Approved',
  rejected: 'Rejected',
  closed: 'Closed',
};

/** The decision as History writes it. */
export const DECISION_LABEL: Record<Exclude<ReviewLink['decision'], 'awaiting'>, string> = {
  approve: 'Approved',
  changes_requested: 'Changes requested',
  reject: 'Rejected',
};
